import { render, staticRenderFns } from "./LogoutLink.vue?vue&type=template&id=589360a6"
import script from "./LogoutLink.vue?vue&type=script&lang=js"
export * from "./LogoutLink.vue?vue&type=script&lang=js"
import style0 from "./LogoutLink.vue?vue&type=style&index=0&id=589360a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports